import moment from 'moment';

const byVehicleMap = {
  van: 1,
  box_van: 2,
  rigid_truck: 3,
  tractor_unit: 4,
  no_type: 99,
};

const getSortValue = (vehicle_type) => byVehicleMap[vehicle_type] || byVehicleMap.no_type;

const byVehicleType = (a, b) => {
  if (getSortValue(b.vehicle_type) < getSortValue(a.vehicle_type)) return 1;

  if (getSortValue(b.vehicle_type) > getSortValue(a.vehicle_type)) return -1;

  return 0;
};

const byDate = (a, b) => {
  if (moment(b.start_date) > moment(a.start_date)) return 1;

  if (moment(b.start_date) < moment(a.start_date)) return -1;

  if (moment(b.end_date) > moment(a.end_date)) return 1;

  if (moment(b.end_date) < moment(a.end_date)) return -1;

  return 0;
};

export { byVehicleType, byDate };
